import React from 'react';
import { Box } from '@mui/material';
import ContactUsHubSpot from './ContactUsHubSpot';
import { useLocale } from '@/contexts/LocaleProvider';

export default function ContactForm() {
    const { locale } = useLocale();

    return (
        <Box
            sx={{
                width: '100%',
                margin: '2rem auto',
                padding: '2rem',
                backgroundColor: '#FAE1D8',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            }}
            data-testid={'contact-us-form'}
        >
            <ContactUsHubSpot locale={locale} />
        </Box>
    );
}
